import { Component, OnInit, HostListener, Input, ViewChild, Output, EventEmitter, Renderer2 } from '@angular/core';
import { NotificationService } from '../../../common/services/notification.service';
import { ProductReviewService } from '../../../finalModule/productReview/productReview.service';
@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  // providers: [PlanProductListingService],
})
export class DrawerComponent implements OnInit {

  constructor(
    private _notificationService: NotificationService,
    private renderer: Renderer2,
    private _productReviewService: ProductReviewService,
  ) { }
  @Input() hideMinimizeBtn = false;
  @Input() isModal = false;
  @Input() drawerId;
  @Input() width?;  // if width === 'half' then show drawer on half of page in size otherwise full in size.
  @Input() centerPosition = false;  // if true, drawer will be centered on screen
  @Output() backdrop = new EventEmitter<any>();
  public openDrawer = false;
  public drawerMinimized = false;
  @Input() allowBodyScroll = false;
  @Input() backdropDisable;
  @Input() showOverlay = true;
  /*** Opens up the drawer */
  public open() {
    this.openDrawer = true;
    if (!this.allowBodyScroll) {
      this.renderer.addClass(document.body, 'overflow-hide');
    }
  }

  /*** Closes the drawer */
  public close() {
    this.openDrawer = false;
    this.renderer.removeClass(document.body, 'overflow-hide');
  }

  /*** Click on the overlay*/
  public showHideDrawer(drawerId) {
    if (drawerId === 'clickToCallDrawer') {
      return;
    }
    this.openDrawer = false;
    if (window.location.href.includes('productReview') && this.drawerId === "resumeOtpDrawer") {
      this.backForOtp();
    }
    if (this.isModal) {
      console.log(this.backdrop);
      if (drawerId === 'addOnsDrawer') {
        let id = document.getElementById('addOnsDrawer').style.setProperty('overflow', 'hidden');
        this._notificationService.notifyOther({ option: 'call_child', DrawerClose: true });
      }
      if (drawerId === 'vehicleTypeDrawer') {
        const body = document.body;
        body.style.overflowY = 'auto';
      }
      else {
        const body = document.body;
        body.style.overflowY = 'auto';
      }
      if (this.showOverlay && !this.backdropDisable) {
        this.renderer.removeClass(document.body, 'overflow-hide');
        console.log(this.backdrop);
        this.openDrawer = false;
        if (this.backdrop !== undefined) {
          this.backdrop.emit();
        }
      }
      this.renderer.removeClass(document.body, 'overflow-hide');
    }
  }
  public compareDrawer(){
    const elem: any = document.getElementById('AddToCompareDrawer');
    if(elem){
      if(!this.drawerMinimized){
        elem.style.setProperty("top", '20rem');
      }
      else{
        elem.style.removeProperty('top');
      }
    }
  }
  ngOnInit() {
  }
  public backForOtp(): any {
    this._productReviewService.postSendMobileOTPForReviewDetails({ action: 'Back' }).subscribe(
      (response: any) => {
        console.log(response);

      },
      err => {
        console.log(err);
      }
    );
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'overflow-hide');
  }
}
